/* eslint-disable max-len */
import React from 'react';
import { Auth } from '@leverege/api-redux';
import { createConnect, TitleBar, Toolbar } from '@leverege/ui-plugin';
import { Config } from '@leverege/plugin';
import { Dialogs, Pane, PortalOverlay, Button } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { Switch } from 'react-router';
import { Routes } from "../../routes/index.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const CLIENT = 'AccountScreen';
const matchContext = {
  use: 'navBar',
  client: CLIENT
};
const {
  t
} = I18N.ns('molten.screens.account.AccountScreen');
class MobileAccountScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  getContext = () => {
    return {
      client: CLIENT,
      clientProps: this.props
    };
  };
  componentDidMount() {
    const {
      setActionsContext,
      setActionsMatchContext,
      setTitle /* setIcon */
    } = this.props;
    if (setActionsMatchContext) setActionsMatchContext({
      data: null
    });
    if (setActionsContext) setActionsContext({
      data: null
    });
    if (setTitle) setTitle({
      data: this.renderTitle
    });
  }
  setTitle = ({
    data
  }) => {
    this.setState({
      title: data
    }, () => {
      const {
        setTitle
      } = this.props;
      if (setTitle) setTitle({
        data: this.renderTitle()
      });
    });
  };
  setIcon = ({
    data
  }) => {
    this.setState({
      icon: data
    });
  };
  renderTitle = () => {
    const {
      title,
      icon
    } = this.state;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Button, {
        variant: "mobileScreenTitle",
        onClick: this.openNavActions,
        icon: icon,
        children: [title, /*#__PURE__*/_jsx("i", {
          className: "fa fa-angle-down fa-fw"
        })]
      }), /*#__PURE__*/_jsx(Toolbar, {
        variant: "actionBar",
        matchContext: {
          client: CLIENT,
          use: 'navActions'
        },
        context: this.getContext()
      })]
    });
  };
  openNavActions = () => {
    Dialogs.show({
      component: NavActions,
      props: {
        context: this.getContext()
      },
      id: 'mobileAccountScreenNavActions'
    });
  };
  render() {
    const {
      setTitle,
      setIcon
    } = this;
    const redirect = Config.get(CLIENT, 'redirectUrl');
    return /*#__PURE__*/_jsx(Switch, {
      children: Routes.getRoutesFor(CLIENT, null, matchContext, {
        setTitle,
        setIcon,
        showHeader: false
      }, redirect)
    });
  }
}
const connect = createConnect(CLIENT, {
  client: CLIENT
});
export default connect(state => {
  return {
    profile: Auth.getProfile(state.auth)
  };
})(MobileAccountScreen);
function NavActions(props) {
  const {
    show,
    onClose,
    context
  } = props;
  return /*#__PURE__*/_jsx(PortalOverlay, {
    show: show,
    onClose: onClose,
    position: "bottom",
    animation: "slideFromBottom",
    children: /*#__PURE__*/_jsxs(Pane, {
      variant: "navSecondaryMobileContainer",
      children: [/*#__PURE__*/_jsx(TitleBar, {
        variant: "navSecondaryMobileTitle|navSecondaryMobile|mobileTitle",
        title: t('title')
      }), /*#__PURE__*/_jsx(Toolbar, {
        vertical: true,
        variant: "navSecondaryMobile",
        matchContext: matchContext,
        context: {
          ...context,
          onClose
        }
      })]
    })
  });
}